import { apiClient } from './client'
import type {
  AttachMaterialRequest,
  AttachToolRequest,
  StepMaterialRef,
  StepToolRef,
  UpdateStepMaterialRequest,
} from './types'

export const attachMaterial = async (
  stepId: string,
  data: AttachMaterialRequest
): Promise<StepMaterialRef> => {
  const response = await apiClient.post<StepMaterialRef>(`/api/v1/steps/${stepId}/materials`, data)
  return response.data
}

export const updateStepMaterial = async (
  stepMaterialId: string,
  data: UpdateStepMaterialRequest
): Promise<StepMaterialRef> => {
  const response = await apiClient.patch<StepMaterialRef>(
    `/api/v1/step-materials/${stepMaterialId}`,
    data
  )
  return response.data
}

export const detachMaterial = async (stepMaterialId: string): Promise<void> => {
  await apiClient.delete(`/api/v1/step-materials/${stepMaterialId}`)
}

export const attachTool = async (stepId: string, data: AttachToolRequest): Promise<StepToolRef> => {
  const response = await apiClient.post<StepToolRef>(`/api/v1/steps/${stepId}/tools`, data)
  return response.data
}

export const detachTool = async (stepToolId: string): Promise<void> => {
  await apiClient.delete(`/api/v1/step-tools/${stepToolId}`)
}
